import React from 'react';
import { Link } from 'react-router-dom';

export default function LandingFooter() {
  return (
    <footer style={{ background: '#1e293b', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
      <div style={{ maxWidth: 1120, margin: '0 auto', padding: '40px 24px 28px' }}>
        {/* Top row */}
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', gap: 24, marginBottom: 32 }}>
          {/* Left */}
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 7, marginBottom: 6 }}>
              <span style={{ width: 7, height: 7, borderRadius: 2, background: '#EA580C', display: 'inline-block' }} />
              <span style={{ fontWeight: 800, fontSize: 16, color: '#ffffff' }}>MetalRecovery</span>
            </div>
            <p style={{ fontSize: 13, color: '#94a3b8', margin: 0, fontWeight: 400 }}>Motor de pricing para recuperadores de metales</p>
          </div>

          {/* Right links */}
          <div style={{ display: 'flex', gap: 24, alignItems: 'center' }}>
            <Link to="/login" style={{ fontSize: 14, color: '#94a3b8', textDecoration: 'none', fontWeight: 500, transition: 'color 0.15s' }}
              onMouseEnter={e => e.currentTarget.style.color = '#e2e8f0'}
              onMouseLeave={e => e.currentTarget.style.color = '#94a3b8'}
            >Iniciar sesión</Link>
            <Link to="/register" style={{ fontSize: 14, color: '#94a3b8', textDecoration: 'none', fontWeight: 500, transition: 'color 0.15s' }}
              onMouseEnter={e => e.currentTarget.style.color = '#e2e8f0'}
              onMouseLeave={e => e.currentTarget.style.color = '#94a3b8'}
            >Registrarse</Link>
          </div>
        </div>

        {/* Bottom line */}
        <div style={{ borderTop: '1px solid #334155', paddingTop: 20, textAlign: 'center' }}>
          <span style={{ fontSize: 13, color: '#64748b' }}>© 2025 MetalRecovery</span>
        </div>
      </div>
    </footer>
  );
}
